module.exports = __webpack_public_path__ + "img/pLine.d7984f79.svg";